import PersonModel from '../modules/person/model/PersonModel'
import PositionModel from '../modules/position/model/PositionModel'
import EducationModel from '../modules/education/model/EducationModel'
import OrganisationModel from '../modules/organisation/model/OrganisationModel'
import LogentryModel from '../modules/logentry/model/LogentryModel'
import LocationModel from '../modules/location/model/LocationModel'
import RelationshipModel from '../modules/relationship/model/RelationshipModel'
import FileModel from '../modules/file/model/FileModel'

export default class ModelMapper {
  mapToModel (data, model) {
    for (let field in data) {
      model[field] = data[field]
    }
  }

  mapToObject (model, data) {
    for (let field in model) {
      data[field] = model[field]
    }
  }

  initToModel (type, data) {
    switch (type) {
      case 'people':
        return new PersonModel(data)
      case 'positions':
        return new PositionModel(data)
      case 'educations':
        return new EducationModel(data)
      case 'organisations':
        return new OrganisationModel(data)
      case 'logentries':
        return new LogentryModel(data)
      case 'locations':
        return new LocationModel(data)
      case 'relationships':
        return new RelationshipModel(data)
      case 'files':
        return new FileModel(data)
    }
  }
}




// WEBPACK FOOTER //
// ./js/lib/ModelMapper.js